import styled from 'styled-components';

export const EmptyMessage = styled.p`
  font-size: 16px;
`;
